import hasPageMeta from '@/mixins/hasPageMeta'

export default {
    mixins: [hasPageMeta],

    computed: {
        computedPageTitle() {
            if (this.$route.query.step) return `${this.pageTitle} Setup - ${this.$route.query.step}`
            return `${this.pageTitle}`
        },

        siteTitle() {
            return this.computedPageTitle
        },

        siteDescription() {
            return 'Looking for wedding vision board ideas? Create a wedding vision board template FREE with Loverly! Comes with all the inspiration you need for a dream wedding'
        },

        previewImage() {
            return require('@/static/saved-ideas/Loverly_Preview_VisionBoard.jpg')
        },

        keywords() {
            return 'free wedding vision board'
        },
    },

    data() {
        return {
            pageTitle: 'Online Wedding Vision Board: Wedding Vision Board Ideas & Inspiration',
        }
    },
}
